import { LoadScript, createSdkResolver } from '@reckon-web/load-script';

import { getPendo } from './getPendo';

export type LoadPendoServiceProps = {
  apiKey: string;
  libraryUrl?: string;
};

/**
 * Pendo Service.
 *
 * https://agent.pendo.io/
 *
 * Usage:
 *
 * `yourapp/src/services/Pendo/loadPendoService.ts`
 * ```ts
 * import { createPendoServiceLoader } from '@reckon-web/pendo';
 *
 * import { Config } from '../Config';
 *
 * export const LoadPendoService = createPendoServiceLoader({
 *  apiKey: Config.APPLICATION_PENDO_APIKEY,
 * });
 * ```
 *
 * `yourapp/src/routes/__root.tsx`
 * ```ts
 * import { LoadPendoService } from '../services/Pendo/loadPendoService';
 *
 * const someHandler = async () => {
 *   LoadPendoService.onReady((pendo) => {
 *     pendo.identify('user-id');
 *   });
 * };
 * ```
 */
export function createPendoServiceLoader({
  apiKey,
  libraryUrl = 'https://cdn.eu.pendo.io/agent/static/{apiKey}/pendo.js',
}: LoadPendoServiceProps) {
  const loader = () => {
    return LoadScript({
      id: 'pendo-service',
      src: libraryUrl.replace('{apiKey}', apiKey),
      parent: 'head',
      async: true,
    });
  };

  return createSdkResolver(loader, getPendo);
}
